import React from 'react';
import PropTypes from 'prop-types';
import { ViewInvoiceIcon } from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/icons/invoices';
import { GoogleTagManager } from '../../../helpers';
import ButtonStyled from './styles/DownloadStyled';

const Download = ({ text, link }) => {
  function downloadLink(url) {
    GoogleTagManager.tagInteractiveEvent({
      eventCategory: 'Boletas',
      eventAction: 'Presionar Botón',
      eventTag: 'Ver PDF',
    });
    const element = document.createElement('a');
    element.setAttribute('href', url);
    element.setAttribute('target', '_blank');
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }
  return (
    <>
      {link && (
        <ButtonStyled
          variant="outlined"
          color="corporate"
          fullWidth
          disabled={!link}
          onClick={() => downloadLink(link)}
          startIcon={<ViewInvoiceIcon />}
        >
          {text}
        </ButtonStyled>
      )}
    </>
  );
};

Download.propTypes = {
  text: PropTypes.string.isRequired,
  link: PropTypes.string,
};

Download.defaultProps = {
  link: '',
};

export default Download;
